import deleteFilter from '../../rest/delete-filter/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, filterId: string): Promise<void> =>
	deleteFilter(baseUrl, filterId);
